/**
 * @generated SignedSource<<d1a9f487883522b858aacc0b49910e6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NavSectionKind = "custom" | "products" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NavSectionFragment$data = {
  readonly apps: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      };
    }>;
  };
  readonly id: string;
  readonly kind: NavSectionKind;
  readonly products: {
    readonly totalCount: number;
  };
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"AppsSidebarList_NavSectionFragment" | "DeleteNavSectionButtonFragment" | "ProductsSidebarList_NavSectionPaginationFragment" | "UpdateNavSectionButtonFragment">;
  readonly " $fragmentType": "NavSectionFragment";
};
export type NavSectionFragment$key = {
  readonly " $data"?: NavSectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavSectionFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavSectionFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductAppNodeConnection",
      "kind": "LinkedField",
      "name": "apps",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductAppNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductApp",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 10
        }
      ],
      "concreteType": "ProductNodeConnection",
      "kind": "LinkedField",
      "name": "products",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": "products(first:10)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UpdateNavSectionButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeleteNavSectionButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductsSidebarList_NavSectionPaginationFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AppsSidebarList_NavSectionFragment"
    }
  ],
  "type": "NavSection",
  "abstractKey": null
};
})();

(node as any).hash = "2c2f64a18601aafbcad9b3a5a4d9dd62";

export default node;
